import React from "react"
import { Datagrid, NumberField, RaRecord } from "react-admin"
import { Chipify } from "common/Chipify"
import { EditIconSmall, EditTablet } from "common/EditField"
import PriceField from "common/PriceField"
import UserService from "UserService"
import { PricingType } from "api/company"

interface PricingRulesDatagridProps {
  type: PricingType
  resource?: string
  noPricesMessage?: string
  onEdit: (record: RaRecord) => void
  onEditTablet?: (record: RaRecord) => void
  showTabletButton?: boolean
}

export const PricingRulesDatagrid = ({
  type,
  resource,
  noPricesMessage = "No bundle prices set",
  onEdit,
  onEditTablet,
  showTabletButton = false
}: PricingRulesDatagridProps) => {
  const isPmOrAdmin = UserService.hasRoles(["ROLE_PLATFORM_MANAGER"])

  return (
    <Datagrid
      resource={resource}
      bulkActionButtons={false}
      className="assigments-datagrid"
      empty={<>{noPricesMessage}</>}
      sx={{
        '& .MuiTableCell-head.column-pricePerWordNewAsset': { textAlign: 'right' },
        '& .MuiTableCell-head.column-pricePerWordRepeatedAsset': { textAlign: 'right' },
        '& .MuiTableCell-head.column-pricePerWordRecycledAsset': { textAlign: 'right' },
        '& .MuiTableCell-head.column-price': { textAlign: 'right' },
        '& .MuiTableCell-head.column-undefined': { textAlign: 'right' },
        '& .MuiTableCell-body.column-pricePerWordNewAsset': { textAlign: 'right' },
        '& .MuiTableCell-body.column-pricePerWordRepeatedAsset': { textAlign: 'right' },
        '& .MuiTableCell-body.column-pricePerWordRecycledAsset': { textAlign: 'right' },
        '& .MuiTableCell-body.column-price': { textAlign: 'right' },
        '& .MuiTableCell-body.column-undefined': { textAlign: 'right' }
      }}
    >
      <Chipify
        source="stages"
        translation="stage.type."
        label="Workflow"
        sortable={false}
        variant="squere-chip"
        fallbackChipLabel="DEFAULT RULE"
        exclude={["FILE_PREPARATION", "FILE_PARSING"]}
      />
      {type !== "FIXED" && (
        <NumberField
          source="price"
          label="Price Per Word"
          textAlign={"right"}
          sortable={false}
          options={{ style: "currency", currencyDisplay: 'code', currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 15 }}
        />
      )}
      {type === "FIXED" && <PriceField label="Price Per Word (New)" sourceField="pricePerWordNewAsset" />}
      {type === "FIXED" && (
        <PriceField label="Price Per Word (Repeated)" sourceField="pricePerWordRepeatedAsset" shouldGrayOut />
      )}
      {type === "FIXED" && (
        <PriceField label="Price Per Word (Recycled)" sourceField="pricePerWordRecycledAsset" shouldGrayOut />
      )}
      {isPmOrAdmin && (
        <EditIconSmall
          label={"Edit"}
          onClick={(e) => {
            onEdit(e)
          }}
        />
      )}
      {showTabletButton && type !== "DYNAMIC" && isPmOrAdmin && onEditTablet && (
        <EditTablet
          label="Tablet"
          onClick={(e) => {
            onEditTablet(e)
          }}
        />
      )}
    </Datagrid>
  )
}
